var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        _vm._l(_vm.tabList, function(tab) {
          return _c(
            "el-tab-pane",
            {
              key: tab.flag,
              attrs: {
                label: tab.name + "(" + tab.number + ")",
                name: String(tab.flag)
              }
            },
            [
              _vm.activeName === String(tab.flag)
                ? _c("contractList", {
                    attrs: {
                      "page-type": "contractList",
                      "contract-type": tab.flag - 1
                    },
                    on: { updateTabList: _vm.handleUpdateTabList }
                  })
                : _vm._e()
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }